<template>
    <div class="register-form">
        <div class="works-register-text" @click="showModal('works-register-modal-ref')">Como funciona o cadastro</div>

        <h2>Olá, tudo bem?</h2>

        <div class="text-link">
            <span>Já possui cadastro?</span>
            <span class="link">
                <router-link to="login">Acesse aqui</router-link>
            </span>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <div class="register-options-btn">
                <b-form-group label="Você é" v-slot="{ ariaDescribedby }">
                    <b-form-radio-group
                        v-model="$v.form.registerSelected.$model"
                        :options="form.registerOptions"
                        :aria-describedby="ariaDescribedby"
                        button-variant="dark"
                        name="register-select"
                        buttons
                    ></b-form-radio-group>
                </b-form-group>
            </div>

            <div class="terms-text">
                <b-form-group>
                    <b-form-checkbox v-model="$v.form.termsStatus.$model" name="terms-status" :unchecked-value="false">
                        <span>Você aceita nossos </span>
                        <span class="link" @click="showModal('use-terms-modal-ref')">Termos de Uso.</span>
                    </b-form-checkbox>

                    <b-form-invalid-feedback :state="validateState('termsStatus')">
                        Precisa aceitar o termo de uso para poder iniciar o cadastro
                    </b-form-invalid-feedback>
                </b-form-group>
            </div>

            <b-button
                type="submit"
                class="radius-6 submit"
                :variant="getIsDarkTheme ? 'primary' : 'dark'"
                :disabled="!$v.form.termsStatus.$model || !$v.form.registerSelected.$model"
            >
                Iniciar cadastro
            </b-button>
        </b-form>

        <b-modal
            ref="works-register-modal-ref"
            body-class="works-register-body-modal"
            ok-only
            ok-title="Fechar"
            ok-variant="secondary"
            size="lg"
            :title="worksRegisterModal.title"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
        >
            <div class="text" v-for="(item, index) in worksRegisterModal.text" :key="index">
                 <div v-html="item"></div>
            </div>
        </b-modal>

        <b-modal
            ref="use-terms-modal-ref"
            body-class="use-terms-body-modal"
            ok-only
            ok-title="Fechar"
            ok-variant="secondary"
            size="lg"
            :title="useTermsModal.title"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
        >
            <div class="content">
                <TermsUseContent />
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required, sameAs } from 'vuelidate/lib/validators'
import { RegisterFirstInformationApi } from '../../api/register-first-information/'
import TermsUseContent from '@/pages/public/terms-use-page/terms-use-content/TermsUseContent'

const registerFirstInformationApi = new RegisterFirstInformationApi()

export default {
    components: { TermsUseContent },
    data() {
        return {
            form: {
                termsStatus: false,
                registerSelected: null,
                registerOptions: []
            },
            worksRegisterModal: {
                title: 'Como funciona o cadastro',
                text: [
                    `O cadastro na plataforma é totalmente gratuito, onde as informações sobre sua iniciativa, projeto, negócio ou organização são fundamentais para estimular possíveis conexões, matchs e outros benefícios. Suas informações separadas em blocos temáticos são armazenadas de forma segura, você também tem o controle sobre o que pode ser exibido no seu perfil público.`,
                    `Quanto mais completo for seu cadastro maiores são as chances de ser encontrado por um possível parceiro.`,
                    `Saiba o que é necessário para efetuar o cadastro na Plataforma Potências Periféricas.`,
                    `<h5>CADASTRO</h5>`,
                    `<strong>Cadastro como Potência Periférica</strong>`,
                    `As potências são divididas em 2 grupos:
                    <li>Potências - podem ou não ter CNPJ e desenvolvem atividades de natureza assistencial, de advocacy, de formação e pesquisa, dentre outros.</li>
                    <li>Prestadores de serviço - precisam ter CNPJ e vendem produtos ou prestam serviços</li>`,
                    `Cadastro como Investidor`,
                    `Um(a) Investidor(a) é uma pessoa física ou jurídica que apoia potências seja financeiramente, ou com outras formas de doação, apoio em pesquisas, consultorias, aceleração, capacitação, entre outros.`,
                    `PREENCHIMENTO`,
                    `O preenchimento do cadastro está dividido em 8 blocos:
                    <li>Primeiras Informações</li>
                    <li>Sobre a Iniciativa</li>
                    <li>Planejamento e Gestão</li>
                    <li>Sustentabilidade Financeira</li>
                    <li>Redes e Parceiros</li>
                    <li>Resultados e Impactos</li>
                    <li>Governança</li>
                    <li>Anexos</li>`,
                    `Sabemos que o cadastro é longo, mas não se assustem, NÃO é necessário preencher tudo de uma vez. Você pode preencher cada bloco quando quiser. No entanto, é necessário preenchê-los na ordem em que aparecem. Por exemplo, ao terminar o bloco Primeiras Informações o que vem a seguir é Sobre a Iniciativas. Se ao terminar o Primeiras Informações você desejar preencher o Redes e Parceiros, por exemplo, isso não será possível.`,
                    `O cadastro é dividido em blocos com níveis diferentes de detalhamento. Com essas informações poderemos:
                    <li>trazer transparência para o trabalho de cada um</li>
                    <li>aumentar a confiança para estabelecer conexões entre iniciativas</li>
                    <li>oferecer uma gama de mais de 50 tipos de filtro para que você encontre com facilidade uma iniciativa com as características que você busca!</li>`,
                    `Ao preencher o cadastro você perceberá que existem dois símbolos em algumas das perguntas: cadeado e asterisco`,
                    `<h5>CADEADO</h5>`,
                    `Nas perguntas que contém um cadeado, você tem a opção de permitir que outros vejam a resposta que inseriu.`,
                    `Disponibilizamos essa opção, pois cuidamos dos seus dados e seguimos a Lei Geral de Proteção de Dados Pessoais - LGPD. Dessa maneira, para informações sensíveis, você terá a possibilidade de deixá-las públicas ou privadas:`,
                    `Todos (as) que acessarem a plataforma poderão ver essa informação.`,
                    `<img src="../../../public/static/img/publico.png" width="80px"/> Todos (as) que acessarem a plataforma poderão ver essa informação.`,
                    `<img src="../../../public/static/img/privado.png" width="80px"/> Somente você e os administradores da plataforma terão acesso à essa informação. Mas, apesar de não estar visível, ela contribuirá para as estatísticas e acompanhamento da plataforma.`,
                    `<h5>ASTERISCO VERMELHO</h5>`,
                    `O asterisco vermelho indica que é necessário responder a pergunta com essa marcação para poder seguir adiante. Caso você deixe uma pergunta com * em branco, não conseguirá avançar.`
                ]
            },
            useTermsModal: {
                title: 'Termos de uso'
            }
        }
    },
    validations: {
        form: {
            registerSelected: { required },
            termsStatus: { sameAs: sameAs(() => true) }
        }
    },
    computed: {
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        }
    },
    methods: {
        ...mapActions(['setIsLoading']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            const firstInfoData = {
                name: null,
                email: null,
                password: null,
                password_confirmation: null,
                cnpj: null,
                cpf: null,
                id_status: 1,
                id_permissao: 1,
                id_acesso: 1,
                ods: [],
                principal_area_atuacao: [],
                estado_desenvolve_acao: null,
                cidade_desenvolve_acao: null,
                nome_organizacao: null,
                possui_cnpj: null,
                descricao_organizacao: null,
                prestador_servico: null,
                id_natureza_inicitiva: null,
                id_formato_juridico: null,
                id_organizacao: this.form.registerSelected,
                id_iniciativa: null,
                percentual: 0.0
            }

            localStorage.setItem('firstInfo', JSON.stringify(firstInfoData))
            this.$router.push('cadastro')
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        }
    },
    mounted() {
        this.setIsLoading(true)
        registerFirstInformationApi.getOrganizationType().then(res => {
            this.form.registerOptions = res.data.map(item => ({ value: item.id, text: item.organizacao }))
            this.setIsLoading(false)
        })
    }
}
</script>

<style scope src="./RegisterForm-light-theme.css"></style>
<style scope src="./RegisterForm-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-form/RegisterForm.vue